import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch";
import {checkOrderApi} from "@CheckOrder/api/checkOrderApi";

export default function useCancelVehicleAddon() {
    const {ticketCode} = useAppSelector((state) => (state.checkOrder.ticket))
    const dispatch = useAppDispatch()

    const cancelAddon = () => {
        dispatch(checkOrderApi.util.updateQueryData('getAddon', {ticketCode}, () => null))
    }

    return {
        cancelAddon,
    }
}